import appConstants from '../constants';
import fetchService from './fetchService';
import capitalizeWords from '../utils/capitalizeWords';

const SERVICE_URL = `${appConstants.SERVICE_BASE_URL}${appConstants.SERVICE_REQUEST_GET_FILTERS_URL}`;

function getCountryList(data) {
  return !!data && 'Countries' in data ?
    data.Countries.map(
      (country) => {
        return Object.fromEntries(
          new Map([
            [appConstants.KEY_NAME, capitalizeWords(country[appConstants.KEY_KEYWORD_DISPLAY_NAME])],
            [appConstants.KEY_CODE, country[appConstants.KEY_KEYWORD_DISPLAY_NAME]],
            [appConstants.KEY_IS_SELECTED, false],
            [appConstants.KEY_IS_DISABLED, false],
            [appConstants.KEY_TYPE, appConstants.VALUE_LOCATION],
            [appConstants.KEY_SUBTYPE, appConstants.VALUE_COUNTRY],
            [appConstants.KEY_ORIGINAL_DATA, { ...country }]
          ])
        )
      }
    ):
    [];
}

function getPartnerRoleList(data) {
  return data.Roles.map(
    (role) => {
      return Object.fromEntries(
        new Map([
          [appConstants.KEY_NAME, role[appConstants.KEY_KEYWORD_DISPLAY_NAME]],
          [appConstants.KEY_CODE, role[appConstants.KEY_KEYWORD_DISPLAY_NAME]],
          [appConstants.KEY_IS_SELECTED, false],
          [appConstants.KEY_IS_DISABLED, role[appConstants.KEY_IS_ACTIVE] ===  'N'],
          [appConstants.KEY_TYPE, appConstants.VALUE_PARTNER_ROLE],
          [appConstants.KEY_SUBTYPE, role[appConstants.KEY_JSONKEY]],
          [appConstants.KEY_ORIGINAL_DATA, { ...role }]
        ])
      )
    }
  );
}

function getPartnerIntegratorLevels(data) {
  return data.Integrator[1][appConstants.KEY_DOCLIST].map(
    (partnerLevel) => {
      return Object.fromEntries(
        new Map([
          [appConstants.KEY_NAME, `${partnerLevel[appConstants.KEY_KEYWORD_DISPLAY_NAME].trim()} ${appConstants.VALUE_INTEGRATOR}`],
          [appConstants.KEY_CODE, `${partnerLevel[appConstants.KEY_KEYWORD_DISPLAY_NAME].trim()} ${appConstants.VALUE_INTEGRATOR}`],
          [appConstants.KEY_IS_SELECTED, false],
          [appConstants.KEY_IS_DISABLED, false],
          [appConstants.KEY_TYPE, appConstants.VALUE_PARTNER_LEVEL],
          [appConstants.KEY_SUBTYPE, appConstants.VALUE_INTEGRATOR],
          [appConstants.KEY_ORIGINAL_DATA, { ...partnerLevel }]
        ])
      )
    }
  );
}

function getPartnerIntegratorSpecializations(data) {
  return data.Integrator[0][appConstants.KEY_DOCLIST].map(
    (partnerSpecialization) => {
      return Object.fromEntries(
        new Map([
          [appConstants.KEY_NAME, partnerSpecialization[appConstants.KEY_KEYWORD_DISPLAY_NAME]],
          [appConstants.KEY_CODE, partnerSpecialization[appConstants.KEY_KEYWORD_DISPLAY_NAME]],
          [appConstants.KEY_IS_SELECTED, false],
          [appConstants.KEY_IS_DISABLED, false],
          [appConstants.KEY_TYPE, appConstants.VALUE_PARTNER_SPECIALIZATION],
          [appConstants.KEY_SUBTYPE, appConstants.VALUE_INTEGRATOR],
          [appConstants.KEY_ORIGINAL_DATA, { ...partnerSpecialization }]
        ])
      )
    }
  );
}

function getPartnerProviderLevels(data) {
  return data.Provider[1][appConstants.KEY_DOCLIST].map(
    (partnerLevel) => {
      return Object.fromEntries(
        new Map([
          [appConstants.KEY_NAME, `${partnerLevel[appConstants.KEY_KEYWORD_DISPLAY_NAME].trim()} ${appConstants.VALUE_PROVIDER}`],
          [appConstants.KEY_CODE, `${partnerLevel[appConstants.KEY_KEYWORD_DISPLAY_NAME].trim()} ${appConstants.VALUE_PROVIDER}`],
          [appConstants.KEY_IS_SELECTED, false],
          [appConstants.KEY_IS_DISABLED, false],
          [appConstants.KEY_TYPE, appConstants.VALUE_PARTNER_LEVEL],
          [appConstants.KEY_SUBTYPE, appConstants.VALUE_PROVIDER],
          [appConstants.KEY_ORIGINAL_DATA, { ...partnerLevel }]
        ])
      )
    }
  );

}

function getPartnerProviderCiscoPoweredServices(data) {
  return data.Provider[0][appConstants.KEY_DOCLIST].map(
    (ciscoPoweredServiceSpecialization) => {
      return Object.fromEntries(
        new Map([
          [appConstants.KEY_NAME, ciscoPoweredServiceSpecialization[appConstants.KEY_KEYWORD_DISPLAY_NAME]],
          [appConstants.KEY_CODE, ciscoPoweredServiceSpecialization[appConstants.KEY_KEYWORD_DISPLAY_NAME]],
          [appConstants.KEY_IS_SELECTED, false],
          [appConstants.KEY_IS_DISABLED, false],
          [appConstants.KEY_TYPE, appConstants.VALUE_PARTNER_SPECIALIZATION],
          //[appConstants.KEY_TYPE, appConstants.VALUE_CISCO_POWERED_SERVICE],
          [appConstants.KEY_SUBTYPE, appConstants.VALUE_PROVIDER],
          [appConstants.KEY_ORIGINAL_DATA, { ...ciscoPoweredServiceSpecialization }]
        ])
      )
    }
  );

}

function getPartnerDeveloperLevels(data) {
  return data.Developer[0][appConstants.KEY_DOCLIST].map(
    (partnerLevel) => {
      return Object.fromEntries(
        new Map([
          [appConstants.KEY_NAME, `${partnerLevel[appConstants.KEY_KEYWORD_DISPLAY_NAME].trim()} ${appConstants.VALUE_DEVELOPER}`],
          [appConstants.KEY_CODE, `${partnerLevel[appConstants.KEY_KEYWORD_DISPLAY_NAME].trim()} ${appConstants.VALUE_DEVELOPER}`],
          [appConstants.KEY_IS_SELECTED, false],
          [appConstants.KEY_IS_DISABLED, false],
          [appConstants.KEY_TYPE, appConstants.VALUE_PARTNER_LEVEL],
          [appConstants.KEY_SUBTYPE, appConstants.VALUE_DEVELOPER],
          [appConstants.KEY_ORIGINAL_DATA, { ...partnerLevel }]
        ])
      )
    }
  );
}

function getPartnerDeveloperSpecializations(data) {
  return [];
}

function getPartnerAdvisorLevels(data) {
  return data.Advisor[0][appConstants.KEY_DOCLIST].map(
    (partnerLevel) => {
      return Object.fromEntries(
        new Map([
          [appConstants.KEY_NAME, `${partnerLevel[appConstants.KEY_KEYWORD_DISPLAY_NAME].trim()} ${appConstants.VALUE_ADVISOR}`],
          [appConstants.KEY_CODE, `${partnerLevel[appConstants.KEY_KEYWORD_DISPLAY_NAME].trim()} ${appConstants.VALUE_ADVISOR}`],
          [appConstants.KEY_IS_SELECTED, false],
          [appConstants.KEY_IS_DISABLED, false],
          [appConstants.KEY_TYPE, appConstants.VALUE_PARTNER_LEVEL],
          [appConstants.KEY_SUBTYPE, appConstants.VALUE_ADVISOR],
          [appConstants.KEY_ORIGINAL_DATA, { ...partnerLevel }]
        ])
      )
    }
  );
}

function getPartnerAdvisorSpecializations(data) {
  return [];
}


export default async function fetchFilters() {
  const fetchedDataObject =
    await fetchService(
      'fetchFilters',
      SERVICE_URL,
      {
        ...appConstants.SERVICE_REQUEST_GET_FILTERS_CONFIG,
        body: JSON.stringify({})
      }
    );

  return !fetchedDataObject.success || (!fetchedDataObject.success && !fetchedDataObject?.Countries)?
    {
      hasError: true,
      errorMessage: fetchedDataObject.statusMessage,
      countryList: [],
      partnerRoleList: [],
      partnerIntegratorLevelList: [],
      partnerIntegratorSpecializationList: [],
      partnerProviderLevelList: [],
      partnerProviderCiscoPoweredServiceList: [],
      partnerDeveloperLevelList: [],
      partnerDeveloperSpecializationList: [],
      partnerAdvisorLevelList: [],
      partnerAdvisorSpecializationList: []
    } :
    {
      hasError: false,
      errorMessage: null,
      countryList: getCountryList(fetchedDataObject.data),
      partnerRoleList: getPartnerRoleList(fetchedDataObject.data),
      partnerIntegratorLevelList: getPartnerIntegratorLevels(fetchedDataObject.data),
      partnerIntegratorSpecializationList: getPartnerIntegratorSpecializations(fetchedDataObject.data),
      partnerProviderLevelList: getPartnerProviderLevels(fetchedDataObject.data),
      partnerProviderCiscoPoweredServiceList: getPartnerProviderCiscoPoweredServices(fetchedDataObject.data),
      partnerDeveloperLevelList: getPartnerDeveloperLevels(fetchedDataObject.data),
      partnerDeveloperSpecializationList: getPartnerDeveloperSpecializations(fetchedDataObject.data),
      partnerAdvisorLevelList: getPartnerAdvisorLevels(fetchedDataObject.data),
      partnerAdvisorSpecializationList: getPartnerAdvisorSpecializations(fetchedDataObject.data),
    };
}
